import React from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";

export const getTableConfig = ({ onShowDetail, onShowStock, pagination }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, limit } = pagination;
        return (page - 1) * limit + tableMeta.rowIndex + 1;
      },
      sort: false,
    },
  },
  {
    name: "partCode",
    label: "Kode Part",
    options: {
      sort: false,
    },
  },
  {
    name: "partName",
    label: "Nama Part",
    options: {
      sort: false,
    },
  },
  {
    name: "category",
    label: "Kategori",
    options: {
      sort: false,
    },
  },
  {
    name: "locatorName",
    label: "Locator",
    options: {
      sort: false,
    },
  },
  {
    name: "quantity",
    label: "QTY",
    options: {
      sort: false,
    },
  },
  {
    name: "qrCode",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <FlexView
            hAlignContent="center"
            vAlignContent="center"
            style={{ gap: "15px" }}
          >
            {val && (
              <SimpleButton
                id="btn_detail"
                category="action_button"
                icon={
                  <i className="fa fa-lg fa-eye color-red txt-site txt-20" />
                }
                onClick={() => onShowDetail(rowIndex)}
              />
            )}
            <SimpleButton
              id="btn_detail"
              category="action_button"
              icon={
                <i className="fa fa-lg fa-clipboard color-red txt-site txt-20" />
              }
              onClick={() => onShowStock(rowIndex)}
            />
          </FlexView>
        );
      },
    },
  },
];

export const getDetailTableConfig = ({ onClickHistory }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;

        const viewIndex =
          tableMeta.rowIndex + 1 - rowsPerPage > 0
            ? tableMeta.rowIndex - rowsPerPage
            : tableMeta.rowIndex;
        const rowNumber = page * rowsPerPage + (viewIndex + 1);

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "qrCode",
    label: "Kode Part",
    options: {
      sort: false,
    },
  },
  {
    name: "qrCode",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return (
          <SimpleButton
            id="btn_detail"
            category="action_button"
            icon={
              <i className="fa fa-lg fa-history color-red txt-site txt-20" />
            }
            onClick={() => onClickHistory(val)}
          />
        );
      },
    },
  },
];

export const getHistoryTableConfig = () => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <React.Fragment>{rowNumber}</React.Fragment>;
      },
      sort: false,
    },
  },
  {
    name: "createdAt",
    label: "Tanggal Transaksi",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return val ? val.split(" ")[0] : null;
      },
    },
  },
  {
    name: "createdAt",
    label: "Jam",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return val ? val?.split(" ")[1] : null;
      },
    },
  },
  {
    name: "transactionType",
    label: "Jenis Transaksi",
    options: {
      sort: false,
    },
  },
  {
    name: "location",
    label: "Locator",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeCabang",
    label: "Kode Cabang",
  },
];

export const getStockTableConfig = ({ onClickItem }) => [
  {
    name: "date",
    label: "Tanggal",
    options: {
      sort: false,
    },
  },
  {
    name: "start",
    label: "Awal",
    options: {
      sort: false,
    },
  },
  {
    name: "in",
    label: "Masuk",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <p
            className="btnAct txt-site txt-blue"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => onClickItem(rowIndex, "trxIn")}
          >
            {val}
          </p>
        );
      },
    },
  },
  {
    name: "out",
    label: "Keluar",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <p
            className="btnAct txt-site txt-blue"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => onClickItem(rowIndex, "trxOut")}
          >
            {val}
          </p>
        );
      },
    },
  },
  {
    name: "finalStock",
    label: "Akhir",
    options: {
      sort: false,
    },
  },
];

export const getDetailStockTableConfig = ({ isQr }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <React.Fragment>{rowNumber}</React.Fragment>;
      },
      sort: false,
    },
  },
  {
    name: "qrCode",
    label: "QR Code",
    options: {
      sort: false,
      display: isQr,
    },
  },
  {
    name: "transactionType",
    label: "Jenis Transaksi",
    options: {
      sort: false,
    },
  },
  {
    name: "qty",
    label: "Jumlah",
    options: {
      sort: false,
      display: !isQr,
    },
  },
  {
    name: "documentId",
    label: "Doc. No",
    options: {
      sort: false,
    },
  },
];
